export default __webpack_public_path__ + "static/media/smsred.419a2d42.svg";